var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRdc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "-5 -2 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48 24.2458L24.0237 0L0 24.2458H7.3274V46H40.6884V24.2458H48Z",
    fill: "#D92228"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1712 17.8924C32.5381 17.2695 31.5253 16.9269 30.3067 16.9269C28.2968 16.9269 27.0307 17.7522 26.1603 18.4685L26.1445 18.4841C25.274 19.3094 24.277 20.4306 23.4541 22.6107C23.4699 22.0034 23.4857 21.1625 23.5015 20.3839C23.5332 19.1693 23.549 18.1259 23.549 18.0014C23.549 17.7366 23.3591 17.4563 22.9476 17.4563H15.1454V18.1104L15.3512 18.1259C15.9842 18.1726 16.5856 18.2349 17.1395 18.6242C17.6301 18.9513 17.9308 19.4028 18.0258 19.979C18.184 20.6486 18.184 22.6107 18.184 23.4516V34.5856C18.184 35.7224 18.1524 37.2796 17.9783 38.323C17.6618 39.3351 17.3294 39.6466 16.6489 39.9892C16.2691 40.1605 15.7943 40.285 15.2562 40.3473L15.0347 40.3629V41.0169H26.6825V40.3629L26.4768 40.3473C26.002 40.3006 25.6539 40.2383 25.1791 40.0359C24.8309 39.9113 24.5302 39.5999 24.2137 39.0237C23.7547 38.0582 23.4699 36.9682 23.4699 34.3209V29.6804C23.4699 28.2789 23.5332 26.9242 23.5807 26.3324C24.1029 22.6263 26.1445 19.652 27.4738 19.652C27.9803 19.652 28.3126 20.197 28.6766 21.0691C29.1039 22.0657 29.7053 23.1246 31.4303 23.1246C33.1395 23.1246 34.0416 21.7075 34.0416 20.2905C34.0574 19.325 33.7726 18.5464 33.1712 17.8924Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRdc);
export default __webpack_public_path__ + "static/media/rdc.724548e4a2b7d3e021df66d2e9206b58.svg";
export { ForwardRef as ReactComponent };